import { useContent } from "@/context/ContentContext";

export const Logo = ({ className = "", dark = false, tagline = false }) => {
  const { getText } = useContent();
  const src = getText("logo.image", "") || "/sedio-logo.png";
  return (
    <a href="#top" data-testid="brand-logo" className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src={src} alt="Sedio" width={38} height={38} className="h-9 w-9 object-contain" />
      <span className="leading-tight">
        <span className={`block font-display text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-foreground"}`}>
          {getText("logo.text", "Sedio")}
        </span>
        {tagline && (
          <span className={`block text-[11px] ${dark ? "text-slate-400" : "text-muted-foreground"}`}>
            {getText("logo.tagline", "L'AI a servizio del condominio")}
          </span>
        )}
      </span>
    </a>
  );
};
